enum authType {
  reset = "reset",
  login = "login",
  signup = "signup",
}

export default authType;
